import { useCallback, useReducer, useMemo } from "react";
function useDialogController(props = false) {
  const { visible, showModal, closeModal } = useDialogControllers({ dialog: props });
  return {
    visible: visible.dialog,
    showModal: useCallback((e) => showModal("dialog")(e), [showModal]),
    closeModal: useCallback((e) => closeModal("dialog")(e), [closeModal])
  };
}
function reducer(state, action) {
  switch (action.type) {
    case "SHOW_MODAL":
      return { ...state, [action.key]: true };
    case "CLOSE_MODAL":
      return { ...state, [action.key]: false };
    default:
      return state;
  }
}
function useDialogControllers(config, defaultOptions = {}) {
  const initialState = getInitialState(config, defaultOptions);
  const [state, dispatch] = useReducer(reducer, initialState);
  const stableConfig = useStable(config);
  const stableOptions = useStable(defaultOptions);
  const showModal = useCallback(
    (id) => (e) => {
      var _a;
      const itemConfig = Object.assign({}, stableOptions, stableConfig[id]);
      if (typeof itemConfig === "object" && (itemConfig == null ? void 0 : itemConfig.stopPropagation) && typeof e === "object")
        (_a = e == null ? void 0 : e.stopPropagation) == null ? void 0 : _a.call(e);
      dispatch({ key: id, type: "SHOW_MODAL" });
    },
    [stableConfig, stableOptions]
  );
  const closeModal = useCallback(
    (id) => (e) => {
      var _a;
      const itemConfig = Object.assign({}, stableOptions, stableConfig[id]);
      if (typeof itemConfig === "object" && (itemConfig == null ? void 0 : itemConfig.stopPropagation) && typeof e === "object")
        (_a = e == null ? void 0 : e.stopPropagation) == null ? void 0 : _a.call(e);
      dispatch({ key: id, type: "CLOSE_MODAL" });
    },
    [stableConfig, stableOptions]
  );
  return {
    visible: state,
    showModal,
    closeModal
  };
}
function getInitialState(originalObject, defaultOptions = {}) {
  return Object.keys(originalObject).reduce((updatedObject, key) => {
    const original = originalObject[key];
    updatedObject[key] = typeof original === "boolean" ? original : original.initialValue || (defaultOptions == null ? void 0 : defaultOptions.initialValue) || false;
    return updatedObject;
  }, {});
}
function useStable(data) {
  return useMemo(() => data, []);
}
export {
  useDialogController,
  useDialogControllers
};
